export const ALLOWED_ORDER_TASKS = [
  'llc_formation',
  'corp_formation',
  'ein_creation',
  'business_license_report',
  'zb_banking_preferred',
  'llc_annual_report',
  'corp_annual_report',
  'llc_amendment',
  'corp_amendment',
  'change_of_registered_agent',
  'ny_publication',
  'registered_agent_service',
  'wfg_initial_report'
];

// this order task type to entitlement
// mapping comes from https://github.com/zenbusiness/entitlements-api/blob/main/server/api/businesses/constants.js

export const EIN_UPSELL = {
  title: 'dashboard.orderTracker.upsell.ein',
  url: '/dashboard/{BUUID}/products/ein-creation',
  entitlement: 'ein_creation'
};

export const BLR_UPSELL = {
  title: 'dashboard.orderTracker.upsell.blr',
  url: '/dashboard/{BUUID}/compliance/business-licenses',
  entitlement: 'business_license_report'
};

export const MONEY_UPSELL = {
  title: 'dashboard.orderTracker.upsell.money',
  url: '/dashboard/{BUUID}/products/money-pro',
  entitlement: 'accounting'
};

export const TAX_ADVISE_UPSELL = {
  title: 'dashboard.orderTracker.upsell.taxAdvise',
  url: '/dashboard/{BUUID}/products/tax-advice',
  entitlement: 'tax_annual_filing'
};

export const TRADEMARKS_SEARCH_UPSELL = {
  title: 'dashboard.orderTracker.upsell.trademarksSearch',
  url: '/dashboard/{BUUID}/products/trademarks-search',
  entitlement: 'trademarks_search'
};

export const WFC_UPSELL = {
  title: 'dashboard.orderTracker.upsell.wfc',
  url: '/dashboard/{BUUID}/products/wfc-services?package=basic',
  entitlement: 'worry_free_service'
};

export const WFC_ADVANCED_UPSELL = {
  title: 'dashboard.orderTracker.upsell.wfcAdvanced',
  url: '/dashboard/{BUUID}/products/wfc-advanced',
  entitlement: 'worry_free_service_advanced'
};

export const NY_PUBLICATION_UPSELL = {
  title: 'dashboard.orderTracker.upsell.nyPublication',
  entitlement: 'ny_publication',
  allowedJurisdictions: ['NY'],
  useSlideSheet: true
};

export const ORDER_TASKS_UPSELLS = {
  llc_formation: [
    EIN_UPSELL,
    NY_PUBLICATION_UPSELL,
    BLR_UPSELL,
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  corp_formation: [
    EIN_UPSELL,
    NY_PUBLICATION_UPSELL,
    BLR_UPSELL,
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  ein_creation: [
    NY_PUBLICATION_UPSELL,
    BLR_UPSELL,
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  business_license_report: [
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  beneficial_ownership_filing: [
    BLR_UPSELL
  ],
  zb_banking_preferred: [
    MONEY_UPSELL,
    TAX_ADVISE_UPSELL
  ],
  ny_publication: [
    BLR_UPSELL
  ]
};

export const TASK_LINK_CONDITIONS = {
  ein_creation: (item, allItems) => {
    if (item.status !== 'incomplete') return false;
    const llcFormation = allItems.find((t) => t.type === 'llc_formation');
    return !llcFormation || llcFormation.status !== 'incomplete';
  }
};

export const SKIPPABLE_STATUSES = ['complete', 'active', 'declined', 'cancelled'];

export const CHIP_COLORS = {
  action_req: 'warning',
  complete: 'secondary',
  incomplete: 'warning',
  pending: 'primary',
  processing: 'info'
};

export const INFO_TOOLTIP_MESSAGES = {
  llc_formation: {
    titleId: 'dashboard.orderTracker.infoTooltip.llc_formation.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.llc_formation.description'
  },
  ein_creation: {
    titleId: 'dashboard.orderTracker.infoTooltip.ein_creation.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.ein_creation.description'
  },
  registered_agent_service: {
    titleId: 'dashboard.orderTracker.infoTooltip.registered_agent_service.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.registered_agent_service.description'
  },
  wfg_initial_report: {
    titleId: 'dashboard.orderTracker.infoTooltip.wfg_initial_report.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.wfg_initial_report.description'
  },
  corp_formation: {
    titleId: 'dashboard.orderTracker.infoTooltip.corp_formation.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.corp_formation.description'
  },
  business_license_report: {
    titleId: 'dashboard.orderTracker.infoTooltip.business_license_report.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.business_license_report.description'
  },
  zb_banking_preferred: {
    titleId: 'dashboard.orderTracker.infoTooltip.zb_banking_preferred.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.zb_banking_preferred.description'
  },
  llc_annual_report: {
    titleId: 'dashboard.orderTracker.infoTooltip.llc_annual_report.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.llc_annual_report.description'
  },
  corp_annual_report: {
    titleId: 'dashboard.orderTracker.infoTooltip.corp_annual_report.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.corp_annual_report.description'
  },
  llc_amendment: {
    titleId: 'dashboard.orderTracker.infoTooltip.llc_amendment.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.llc_amendment.description'
  },
  corp_amendment: {
    titleId: 'dashboard.orderTracker.infoTooltip.corp_amendment.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.corp_amendment.description'
  },
  change_of_registered_agent: {
    titleId: 'dashboard.orderTracker.infoTooltip.change_of_registered_agent.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.change_of_registered_agent.description'
  },
  ny_publication: {
    titleId: 'dashboard.orderTracker.infoTooltip.ny_publication.title',
    descriptionId: 'dashboard.orderTracker.infoTooltip.ny_publication.description'
  }
};

export const SERVICE_EVENT_PROPERTIES = Object.freeze({
  beneficial_ownership_filing: {
    elementValue: 'beneficial_ownership_filing',
    elementText: 'Beneficial Ownership Filing'
  },
  business_license_report: {
    elementValue: 'business_license_report',
    elementText: 'Business License Report'
  },
  change_of_registered_agent: {
    elementValue: 'change_of_registered_agent',
    elementText: 'Change of Registered Agent'
  },
  corp_amendment: {
    elementValue: 'corp_amendment',
    elementText: 'Corp Amendment'
  },
  corp_annual_report: {
    elementValue: 'corp_annual_report',
    elementText: 'Corp Annual Report'
  },
  corp_formation: {
    elementValue: 'corp_formation',
    elementText: 'Corp Formation'
  },
  ein_creation: {
    elementValue: 'ein_creation',
    elementText: 'EIN Creation'
  },
  llc_amendment: {
    elementValue: 'llc_amendment',
    elementText: 'LLC Amendment'
  },
  llc_annual_report: {
    elementValue: 'llc_annual_report',
    elementText: 'LLC Annual Report'
  },
  llc_formation: {
    elementValue: 'llc_formation',
    elementText: 'LLC Formation'
  },
  ny_publication: {
    elementValue: 'ny_publication',
    elementText: 'NY Publication'
  },
  registered_agent_service: {
    elementValue: 'registered_agent_service',
    elementText: 'Registered Agent'
  },
  wfg_initial_report: {
    elementValue: 'wfg_initial_report',
    elementText: 'Initial Report'
  },
  zb_banking_preferred: {
    elementValue: 'zb_banking_preferred',
    elementText: 'ZB Banking Preferred'
  }
});
